<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <div class="avatar">
                            <v-avatar class="page-icon teal mr-2 elevation-5">
                                <v-icon large class="white--text">
                                    {{ mdiPlusBox }}
                                </v-icon>
                            </v-avatar>
                        </div>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Annual Check Up
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>

        <!-- Cards -->

        <div class="affiliatedWrapper">
            <v-card
                class="card"
                raised
                @click="
                    $router.push(`/dashboard/annual-physical-exam/main`)
                "
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column ape-btn">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5">
                            <v-icon size="50" class="white--text">
                                {{ mdiFileDocument }}
                            </v-icon>
                        </v-avatar>
                        Annual Check Up Request
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="
                    $router.push(`/dashboard/consultation/history/`)
                "
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5">
                            <v-icon size="50" class="white--text">
                                {{ mdiTable }}
                            </v-icon>
                        </v-avatar>
                        History
                    </v-card-title>
                </v-card-text>
            </v-card>
            <!-- <v-card
          class="card"
          raised
          @click="
            $router.push(`/dashboard/annual-physical-exam/revalidate`)
          "
          ><v-card-text>
            <v-card-title class="text--primary d-flex flex-column">
              <v-avatar size="80" class="teal mr-2 my-4 elevation-5">
                <v-icon size="50" class="white--text">mdiRefresh</v-icon>
              </v-avatar>
              Revalidate Approval</v-card-title
            >
          </v-card-text></v-card
        > -->
            <!-- <div v-else class="error_message_eligibility">
          <p>{{  this.message }}</p>
        </div> -->
            <!-- <div v-else>
          <p>Please wait ...</p>
          <p>Annual physical exams are currently unavailable. Please try again later.</p>
        </div> -->
        </div>
    </section>
</template>

  <script>
import { 
    mdiDoctor, 
    mdiFileDocument, 
    mdiTable,
    mdiPlusBox
} from '@mdi/js'

// import { mapActions, mapGetters } from "vuex";
export default {
    data: () => {
        return({
            // message: ''
            mdiFileDocument,
            mdiDoctor,
            mdiTable,
            mdiPlusBox
        })
    }
    // computed: {
    //   ...mapGetters(["getEligibilityAPE"])
    // },
    // methods: {
    // ...mapActions(["getCsrfToken"]),
    // ...mapActions(["getCsrfToken", "isEligibleForAPE"]),
    // async get_ape_status() {
    //   await this.getCsrfToken();
    //   await this.isEligibleForAPE({ MEMBN: this.$cookies.get("usermembn") });
    //   const ape_status = this.getEligibilityAPE; // Retrieve updated state
    //   return ape_status;
    // }
    // },
    // async mounted() {
    //   try {
    //     const ape_status = await this.get_ape_status();
    //     if (ape_status.eligible === false) {
    //       this.message = ape_status.message;
    //     }
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }
}
  </script>

  <style scoped>
  section {
    background-image: url("../../assets/dashboardBG.webp");
    background-position: center;
    background-size: cover;
  }
  .affiliatedWrapper {
    height: 90%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
  }
  .card {
    width: 300px;
    height: 200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: linear-gradient(180deg, #b4ff9a 0%, #02cf9f 100%);
  }
  .ape-btn {
    word-break: normal;
    text-align: center;
  }
  .error_message_eligibility {
    position: absolute;
    top: 200px;
    margin: 0 50px;
    /* background-color: red; */
  }

  @media (max-width: 390px) {
    .page-icon {
      display: none;
    }
    .error_message_eligibility {
      margin: 0 50px;
      /* background-color: red; */
    }
  }

  @media (max-width: 599px) {
    /* Navbar */
    .nav {
      margin-top: 60px;
    }
    .nav h2 {
      font-size: 25px;
    }
    .avatar {
      margin: 10px auto;
    }
    .card {
      height: 200px;
      width: 250px;
      margin: 10px auto;
    }
    .error_message_eligibility {
      margin: 0 50px;
      /* background-color: red; */
      position: absolute;
      top: 200px;
    }
  }

  @media (min-width: 599px) and (max-width: 1264px) {
    /* Navbar */
    .nav {
      margin-top: 60px;
    }
    .nav h2 {
      font-size: 25px;
    }
    .error_message_eligibility {
      position: absolute;
      top: 200px;
      margin: 0 50px;
      /* background-color: red; */
    }
  }
  </style>
